import { render } from "./AnnotationsListItem.vue?vue&type=template&id=22fe43db&scoped=true"
import script from "./AnnotationsListItem.vue?vue&type=script&lang=js"
export * from "./AnnotationsListItem.vue?vue&type=script&lang=js"

import "./AnnotationsListItem.vue?vue&type=style&index=0&id=22fe43db&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fe43db"]])

export default __exports__